import React from 'react';
import {
  StyleSheet,
  View,
  StyleProp,
  ViewStyle,
  Text,
  TouchableOpacity,
} from 'react-native';
import {ChevronRightIcon} from './components';
import {colors} from 'src/assets';

export type FormControlPriceSubItem = {
  title: string;
  detail: string;
  color: 'gray' | 'red';
};

export type FormControlPriceProps = {
  containerStyle?: StyleProp<ViewStyle>;
  text: string;
  price?: string;
  priceSubItems?: FormControlPriceSubItem[];
  error?: string;
  onPress?: () => void;
};

export const FormControlPrice: React.FC<FormControlPriceProps> = ({
  containerStyle,
  text,
  price,
  priceSubItems,
  error,
  onPress,
}) => {
  return (
    <TouchableOpacity
      style={[styles.container, containerStyle]}
      onPress={onPress}>
      <View style={styles.content}>
        <Text style={styles.text}>{text}</Text>
        <View style={styles.rightContainer}>
          <Text style={[styles.price, price ? styles.priceActive : {}]}>
            {price ? price : '(必須)'}
          </Text>
          <ChevronRightIcon style={styles.rightIcon} />
        </View>
      </View>
      <View style={styles.priceContainer}>
        {priceSubItems?.map((item, index) => (
          <View key={index} style={styles.priceSubItem}>
            <Text
              style={[
                styles.priceSubItemText,
                item.color === 'red' ? styles.priceSubItemRed : {},
              ]}>
              {item.title}
            </Text>
            <Text
              style={[
                styles.priceSubItemDetail,
                item.color === 'red' ? styles.priceSubItemRed : {},
              ]}>
              {item.detail}
            </Text>
          </View>
        ))}
      </View>
      {error ? <Text style={styles.error}>{error}</Text> : null}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    backgroundColor: colors.white,
    flexDirection: 'column',
    borderBottomColor: colors.gray1,
    borderBottomWidth: 1,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    flex: 1,
    color: colors.chokuGray,
    fontSize: 14,
    marginRight: 16,
  },
  rightContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  priceContainer: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginRight: 12,
  },
  price: {
    color: colors.chokyGray10,
    fontSize: 14,
    width: 130,
    textAlign: 'right',
  },
  priceActive: {
    fontWeight: 'bold',
  },
  priceSubItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 4,
  },
  priceSubItemText: {
    color: colors.chokyGray10,
    fontSize: 12,
  },
  priceSubItemDetail: {
    color: colors.chokyGray10,
    fontSize: 14,
    fontWeight: 'bold',
    width: 130,
    textAlign: 'right',
  },
  priceSubItemRed: {
    color: colors.chokuRed,
  },
  rightIcon: {
    marginLeft: 8,
  },
  error: {
    color: colors.chokuRed,
  },
});
